import {createContext, PropsWithChildren} from "react";
import {baseTheme} from "@/theming/baseTheme";

export const BaseThemeContext = createContext<{theme: typeof baseTheme} | null>(null);

export const BaseThemeProvider = ({children}: PropsWithChildren) => {
    return (
        <BaseThemeContext.Provider value={{theme: baseTheme}}>
            {children}
        </BaseThemeContext.Provider>
    );
};
